import { render, staticRenderFns } from "./VPrescriptionDrawingUploadControls.vue?vue&type=template&id=d2ef048e&functional=true&"
var script = {}
import style0 from "./VPrescriptionDrawingUploadControls.vue?vue&type=style&index=0&id=d2ef048e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports